import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  output,
  signal,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ECompetitionTab } from '../../models';

interface ITapOption {
  title: string;
  isSelected: boolean;
  value: ECompetitionTab;
}

@Component({
  selector: 'app-competition-tabs',
  standalone: true,
  imports: [],
  templateUrl: './competition-tabs.component.html',
  styleUrl: '../../../../../../styles/tab-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompetitionTabsComponent {
  private readonly translateService = inject(TranslateService);

  onSelectTab = output<ECompetitionTab>();
  selectedTab = signal<ECompetitionTab>(ECompetitionTab.MATCHES);
  tabOptions = computed<ITapOption[]>(() => [
    {
      title: this.translateService.instant('Matches'),
      isSelected: true,
      value: ECompetitionTab.MATCHES,
    },
    {
      title: this.translateService.instant('Scores'),
      isSelected: false,
      value: ECompetitionTab.RESULTS,
    },
    {
      title: this.translateService.instant('Standing'),
      isSelected: false,
      value: ECompetitionTab.STANDINGS,
    },
  ]);

  displayedTapOptions = computed(() =>
    this.tabOptions().map((item) => ({
      ...item,
      isSelected: item.value === this.selectedTab(),
    }))
  );

  handleSetTap = (value: ECompetitionTab) => {
    this.selectedTab.set(value);
    this.onSelectTab.emit(value);
  };
}
